<template>

    <div class="animated fadeIn">

        <b-row class="text-center mt-4">
            <b-col>
                <h2>¡MUCHAS GRACIAS!</h2>
            </b-col>
        </b-row>

        <b-row class="text-center mt-2">
            <b-col>
                <h3>Muchas gracias por tu tiempo y tu interes. Ya hemos terminado</h3>
            </b-col>
        </b-row>

        <b-row class="mt-4">
            <b-col>
                <h5>Si quiere, podemos ponernos en contacto contigo para realizar un seguimiento sobre esta encuesta.</h5>
            </b-col>
        </b-row>

        <b-row class="mt-2">
            <b-col>

                <b-form-group class="m-0">
                     <b-form-radio-group 
                        id="options" 
                        name="group-radios"
                        v-model="valuation"
                    >
                        <b-form-radio class="mt-1" value="true"><h5>Si, podéis contactarme.</h5></b-form-radio>
                        <b-form-radio class="mt-1" value="false"><h5>No, no contactéis conmigo.</h5></b-form-radio>
                    </b-form-radio-group>
                </b-form-group>

            </b-col>
        </b-row>

    </div>

</template>

<script>
    import ValuationSelector from "./ValuationSelector";

    export default {
        name: "ContactQuestion",
        components: {
            ValuationSelector
        },
        props: {
            value: Boolean
        },
        data: function () {
            return {
                valuation: null
            }
        },
        mounted() {
            this.valuation = this.value ? 'true' : 'false';
        },
        watch: {
            'valuation': function(){
                this.$emit('input', this.valuation === 'true');
            },
        }
    }
</script>